import { CollectionFunctionFormFieldHandler } from '../components/CollectionFunctionForm';
import { useFieldCreateNewCollectionFunctionGroup } from './useFieldCreateNewCollectionFunctionGroup';
import { useFieldCreateNewNetwork } from './useFieldCreateNewNetwork';
import { useFieldCreateNewSecurityInfo } from './useFieldCreateNewSecurityInfo';
import { useFieldCreateNewCfFtpInfo } from './useFieldCreateNewCfFtpInfo';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNew(
  handleFieldUpdate: CollectionFunctionFormFieldHandler,
): [CollectionFunctionFormFieldHandler] {
  const [handleFieldCollectionFunctionGroup] = useFieldCreateNewCollectionFunctionGroup(handleFieldUpdate);
  const [handleFieldNetwork] = useFieldCreateNewNetwork(handleFieldUpdate);
  const [handleFieldSecurityInfo] = useFieldCreateNewSecurityInfo(handleFieldUpdate);
  const [handleFieldCfFtpInfo] = useFieldCreateNewCfFtpInfo(handleFieldUpdate);

  const handleFieldCreateNew: CollectionFunctionFormFieldHandler = (
    param,
    formSection,
    tabId,
  ) => {
    const { name } = param;

    if (formSection === 'main' && name === 'cfGroup') {
      handleFieldCollectionFunctionGroup(param, formSection, tabId);
    } else if (formSection === 'facilityInformation' && name === 'ftpId') {
      handleFieldCfFtpInfo(param, formSection, tabId);
    } else if (formSection === 'hi2Interfaces' || formSection === 'hi3Interfaces') {
      if (name === 'ownnetid') {
        handleFieldNetwork(param, formSection, tabId);
      } else if (name === 'secinfoid') {
        handleFieldSecurityInfo(param, formSection, tabId);
      }
    }
  };

  return [handleFieldCreateNew];
}
